import { gql } from "@apollo/client";

export const Get_Task_Statuses = gql`
  query GetTaskStatuses(
    $skip: Int
    $take: Int
    $where: TaskStatusFilterInput
    $order: [TaskStatusSortInput!]
  ) {
    taskStatuses(skip: $skip, take: $take, where: $where, order: $order) {
      totalCount
      items {
        id
        name
        color
        isDefault
        createdOn
        sortOrder
      }
    }
  }
`;
export const Get_Task_Types = gql`
  query GetTaskTypes(
    $skip: Int
    $take: Int
    $where: TaskTypeFilterInput
    $order: [TaskTypeSortInput!]
  ) {
    taskTypes(skip: $skip, take: $take, where: $where, order: $order) {
      totalCount
      items {
        id
        name
        createdOn
      }
    }
  }
`;
export const Get_Task_Priorities = gql`
  query GetTaskPriorities(
    $skip: Int
    $take: Int
    $where: TaskPriorityFilterInput
    $order: [TaskPrioritySortInput!]
  ) {
    taskPriorities(skip: $skip, take: $take, where: $where, order: $order) {
      totalCount
      items {
        id
        name
        color
        createdOn
      }
    }
  }
`;
export const Get_Task_Reminders = gql`
  query GetTaskReminders(
    $skip: Int
    $take: Int
    $where: DefaultTaskReminderFilterInput
    $order: [DefaultTaskReminderSortInput!]
  ) {
    defaultTaskReminders(
      skip: $skip
      take: $take
      where: $where
      order: $order
    ) {
      totalCount
      items {
        id
        unit
        value
        sortOrder
      }
    }
  }
`;

export const Get_Call_Results = gql`
  query GetCallResults($skip: Int, $take: Int) {
    callResult(skip: $skip, take: $take) {
      items {
        id
        value
      }
    }
  }
`;
export const Get_Call_Purpose = gql`
  query GetCallPurpose($skip: Int, $take: Int) {
    callPurpose(skip: $skip, take: $take) {
      items {
        id
        value
      }
    }
  }
`;
